// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-upload {\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n}\n.image-upload input[type=\"file\"] {\n  position: absolute;\n  display: inline-block;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.image-upload image {\n  display: inline-block;\n}\n.image-upload.hover {\n  opacity: 0.5;\n}\n", ""]);
// Exports
module.exports = exports;
